import { render } from "./ReportSales.vue?vue&type=template&id=45c87bb3&scoped=true"
import script from "./ReportSales.vue?vue&type=script&lang=js"
export * from "./ReportSales.vue?vue&type=script&lang=js"

import "./ReportSales.vue?vue&type=style&index=0&id=45c87bb3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c87bb3"]])

export default __exports__